export interface ValidationSchema {
  rule: string | RegExp;
  message: string;
}

/* eslint-disable no-useless-escape */

export abstract class Validation {
  public static readonly NOT_EMPTY: ValidationSchema = {
    rule: '(?!^$)([^\\s])',
    message: 'Field must be filled out',
  };

  public static readonly EMAIL: ValidationSchema = {
    // RFC 2822: http://tools.ietf.org/html/rfc2822#section-3.4.1
    // eslint-disable-next-line
    rule: /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/,
    message: 'Provided email is invalid',
  };

  public static readonly PHONE: ValidationSchema = {
    // RFC 2822: http://tools.ietf.org/html/rfc2822#section-3.4.1
    // eslint-disable-next-line
    rule: "^\\(?([0-9]{3})\\)?[-.\\s]?([0-9]{3})[-.\\s]?([0-9]{4})$",
    message: 'Provided phone is invalid',
  };

  public static readonly FULLNAME: ValidationSchema = {
    // RFC 2822: http://tools.ietf.org/html/rfc2822#section-3.4.1
    // eslint-disable-next-line
    rule: /^([a-zA-Z0-9]+|[a-zA-Z0-9]+\s{1}[a-zA-Z0-9]{1,}|[a-zA-Z0-9]+\s{1}[a-zA-Z0-9]{3,}\s{1}[a-zA-Z0-9]{1,})$/,
    message: 'Provided name is invalid',
  };
}

// VV-226: the exchange comment is ES-indexed, so it rides along on every search hit for the
// asset whether or not anything displays it - a page of 200 hits carries 200 comments. Capped
// rather than unbounded for that reason. vault-api enforces the same limit independently and
// rejects an over-length comment with a 400, so this is a courtesy check, not the only one.
export const EXCHANGE_COMMENT_MAX_LENGTH = 1000;

export enum SharedAssetExpiration {
  Default = 1,
  Min = 1,
  Max = 7,
}
